export const piClubs = [
  "American Steamship Owners Mutual Protection and Indemnity Association, Inc",
  "American Club (Europe)",
  "The Britannia Steam Ship Insurance Association Limited",
  "The Britannia Steam Ship Insurance Association Europe",
  "Gard P&I (Bermuda) Ltd.",
  "Assuranceforeningen Gard (Gjensidig)",
  "The Japan Ship Owners' Mutual Protection & Indemnity Association",
  "The London Steam-Ship Owners' Mutual Insurance Association Limited",
  "The London P&I Insurance Company (Europe) Limited",
  "NorthStandard Limited",
  "NorthStandard EU DAC (previously named North of England P&I DAC)",
  "The Standard Club UK Ltd",
  "The Standard Club Asia Ltd",
  "The Standard Club Ireland DAC",
  "The Shipowners' Mutual Protection & Indemnity Association (Luxembourg)",
  "Assuranceforeningen Skuld (Gjensidig)",
  "Skuld Mutual Protection and Indemnity Association (Bermuda) Ltd.",
  "The Steamship Mutual Underwriting Association (Bermuda) Limited",
  "Steamship Mutual Underwriting Association Ltd.",
  "Steamship Mutual Underwriting Association (Europe) Limited",
  "Sveriges Ångfartygs Assurans Förening / The Swedish Club",
  "The United Kingdom Mutual Steam Ship Assurance Association Ltd",
  "UK P&I (Bermuda)",
  "UK P&I (UKNV)",
  "The West of England Ship Owners Mutual Insurance Association (Luxembourg)",
  "The North of England Protecting & Indemnity Association Limited",
  "The Standard Club Ltd",
  "Other (Specify)",
];
